// extracted by mini-css-extract-plugin
export default {"tableWrapper":"ClientTransactionTable_tableWrapper__y9Mep","table":"ClientTransactionTable_table__LWHdF"};